// src/utils/getTeamLogo.js

const normalizeKey = (value) => {
  if (!value) return "";
  let v = value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  v = v.replace(/&/g, "and");
  v = v.replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
  v = v.replace(/\b(fc|afc|cf|sc|ud|cd|club|de|del|la|el|the|calcio|ac|as|ss)\b/g, "");
  v = v.replace(/\s+/g, " ").trim();
  return v.replace(/[^a-z0-9]/g, "");
};

const TEAM_KEY_ALIASES = {
  // EPL naming variants
  wolves: "wolverhamptonwanderers",
  wolverhampton: "wolverhamptonwanderers",
  brighton: "brightonhovealbion",
  brightonandhovealbion: "brightonhovealbion",
  westham: "westhamunited",
  westhamunitedfc: "westhamunited",
  newcastle: "newcastleunited",
  newcastleunitedfc: "newcastleunited",
  tottenham: "tottenhamhotspur",
  tottenhamhotspurfc: "tottenhamhotspur",
  bournemouth: "bournemouth",
  afcbournemouth: "bournemouth",
  sunderland: "sunderland",
  sunderlandafc: "sunderland",
  mancity: "manchestercity",
  manunited: "manchesterunited",

  // LaLiga naming variants
  athletic: "athleticbilbao",
  athleticclub: "athleticbilbao",
  atleticodemadrid: "atleticomadrid",
  atleticomadrid: "atleticomadrid",
  clubatleticodemadrid: "atleticomadrid",
  celta: "celtavigo",
  rcceltadevigo: "celtavigo",
  rcceltavigo: "celtavigo",
  celtavigo: "celtavigo",
  rayovallecanomadrid: "rayovallecano",
  osasuna: "caosasuna",
  caosasuna: "caosasuna",
  realbetis: "realbetisbalompie",
  realbetisbalompie: "realbetisbalompie",
  barcelona: "barcelona",
  fcbarcelona: "barcelona",
  mallorca: "rcdmallorca",
  rcdmallorca: "rcdmallorca",
  sevilla: "sevillafc",
  sevillafc: "sevillafc",
  getafe: "getafecf",
  getafecf: "getafecf",
  espanyol: "rcdespanyolbarcelona",
  rcdespanyoldebarcelona: "rcdespanyolbarcelona",
  alaves: "deportivoalaves",
  deportivoalaves: "deportivoalaves",
  deportivo: "rcdeportivolacoruna",
  rcdeportivolacoruna: "rcdeportivolacoruna",
  santander: "realracingclubdesantander",
  realracingclubdesantander: "realracingclubdesantander",
  barca: "fcbarcelona",
  girona: "gironafc",
  gironafc: "girona",
  realmadrid: "realmadrid",
  realmadridcf: "realmadrid",
  realsociedad: "realsociedad",
  realsociedaddefutbol: "realsociedad",
  realsociedadfutbol: "realsociedad",
  villarreal: "villarrealcf",
  villarrealcf: "villarrealcf",
  valencia: "valenciacf",
  valenciacf: "valenciacf",
  athleticbilbao: "athleticbilbao",

  // Bundesliga variants
  bayernmunchen: "bayernmunich",
  bayernmunich: "bayernmunich",
  bayern: "bayernmunich",
  bayerleverkusen: "bayer04leverkusen",
  leverkusen: "bayer04leverkusen",
  dortmund: "borussiadortmund",
  borussiadortmund: "borussiadortmund",
  rbleipzig: "rbleipzig",
  stuttgart: "vfbstuttgart",
  vfbstuttgart: "vfbstuttgart",
  frankfurt: "eintrachtfrankfurt",
  eintrachtfrankfurt: "eintrachtfrankfurt",
  freiburg: "scfreiburg",
  scfreiburg: "scfreiburg",
  mainz: "1fsvmainz05",
  mainz05: "1fsvmainz05",
  unionberlin: "1fcunionberlin",
  heidenheim: "1fcheidenheim1846",
  fcheidenheim: "1fcheidenheim1846",
  wolfsburg: "vflwolfsburg",
  bochum: "vflbochum",
  stpauli: "fcstpauli",
  fcstpauli: "fcstpauli",
  fcstpauli1910: "fcstpauli",
  hoffenheim: "tsg1899hoffenheim",
  werderbremen: "svwerderbremen",
  monchengladbach: "borussiamonchengladbach",
  borussiamonchengladbach: "borussiamonchengladbach",
  augsburg: "fcaugsburg",
  fcaugsburg: "fcaugsburg",
  hamburgersv: "hamburgersv",
  hamburg: "hamburgersv",
  "1fckoln": "koln",
  "1koln": "koln",
  fckoln: "koln",
  koln: "koln",

  // Serie A variants
  inter: "intermilan",
  intermilan: "intermilan",
  intermilano: "intermilan",
  fcinternazionalemilano: "intermilan",
  milan: "milan",
  acmilan: "milan",
  juventus: "juventus",
  juventusfc: "juventus",
  roma: "roma",
  asroma: "roma",
  lazio: "lazio",
  sslazio: "lazio",
  napoli: "napoli",
  sscnapoli: "napoli",
  napolicalcio: "sscnapoli",
  atalanta: "atalantabc",
  atalantabc: "atalantabc",
  fiorentina: "acffiorentina",
  acffiorentina: "acffiorentina",
  torino: "torinofc",
  torinofc: "torinofc",
  bologna: "bolognafc1909",
  bolognafc1909: "bolognafc1909",
  genoa: "genoacfc",
  genoacfc: "genoacfc",
  cagliari: "cagliaricalcio",
  cagliaricalcio: "cagliaricalcio",
  empoli: "fcempoli",
  fcempoli: "fcempoli",
  udinese: "udinesealcio",
  udinesealcio: "udinesealcio",
  lecce: "uslecce",
  uslecce: "uslecce",
  verona: "hellasverona",
  hellasverona: "hellasverona",
  parma: "parma1913",
  parmacalcio1913: "parma1913",
  acmonza: "acmonza",
  monza: "acmonza",
};

const contexts = {
  "england__premier_league": require.context("./assets/logos/england__premier_league", false, /\.png$/),
  "spain__laliga": require.context("./assets/logos/spain__laliga", false, /\.png$/),
  "germany__bundesliga": require.context("./assets/logos/germany__bundesliga", false, /\.png$/),
  "italy__serie_a": require.context("./assets/logos/italy__serie_a", false, /\.png$/),
};

const buildIndex = (ctx) => {
  const index = {};
  ctx.keys().forEach((key) => {
    const file = key.replace("./", "").replace(".png", "");
    const norm = normalizeKey(file);
    index[norm] = ctx(key);
  });
  return index;
};

const leagueIndexes = {};
Object.keys(contexts).forEach((league) => {
  leagueIndexes[league] = buildIndex(contexts[league]);
});

export const getTeamLogo = (teamName, leagueHint = "") => {
  if (!teamName) return null;
  const normalized = TEAM_KEY_ALIASES[normalizeKey(teamName)] || normalizeKey(teamName);
  const hinted = leagueIndexes[leagueHint];
  if (hinted && hinted[normalized]) return hinted[normalized];

  // Try all leagues as fallback
  for (const league of Object.keys(leagueIndexes)) {
    const hit = leagueIndexes[league][normalized];
    if (hit) return hit;
  }

  return null;
};

export const getTeamInitials = (teamName) => {
  const raw = (teamName || "").trim();
  if (!raw) return "?";
  const words = raw
    .replace(/&/g, " ")
    .split(/\s+/)
    .filter(
      (w) =>
        w &&
        !["fc", "afc", "cf", "sc", "ac", "as", "ss", "club", "de", "del", "the"].includes(
          w.toLowerCase()
        )
    );
  if (words.length === 0) return raw.slice(0, 2).toUpperCase();
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0] || ""}${words[1][0] || ""}`.toUpperCase();
};
